

const peer_config = {
    //host: `192.168.72.129`, //test
    host: `/`, //prod
    //port: 4000, //test
    path: "/peerjs", 
    config: {
      iceServers: [
        { url: "stun:stun.l.google.com:19302" },
        { url: "stun:stun1.l.google.com:19302" },
        { url: "stun:stun2.l.google.com:19302" },
        { url: "stun:stun3.l.google.com:19302" },
        { url: "stun:stun4.l.google.com:19302" },
        { url: "stun:stun.ekiga.net" },
        { url: "stun:stun.stunprotocol.org:3478" },
        { url: "stun:stun.voipbuster.com" },
        { url: "stun:stun.voipstunt.com" },
      ],
    },
    debug: 3,
}

export default peer_config;